// src/features/rrhh/mensajeria/components/MensajesList.jsx
import { Box, Stack } from "@mui/material";
import MensajeCard from "./MensajeCard";

export default function MensajesList({ items = [], selectedId, onSelect, withSurface = true }) {
  const list = (
    <Stack
      spacing={1}
      sx={{
        height: "43.5vh",
        overflow: "hidden",
        overflowY: "auto",
        pr: 0.5,
      }}
    >
      {items.map((m) => (
        <MensajeCard
          key={m.id}
          message={m}
          active={m.id === selectedId}
          onClick={() => onSelect?.(m.id)}
        />
      ))}
      {items.length === 0 ? <Box sx={{ p: 2, opacity: 0.75 }}>No hay resultados.</Box> : null}
    </Stack>
  );

  if (!withSurface) return <Box>{list}</Box>;

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: "20px",
        bgcolor: (t) => t.palette?.neutral?.[150],
        boxShadow: "inset 0px 0px 4px rgba(117, 117, 138, 0.45)",
      }}
    >
      {list}
    </Box>
  );
}
